import { useIsZendeskHelpCenterSsoEnabled } from "@src/appV2/redesign/HelpCenter/hooks/useIsZendeskHelpCenterSsoEnabled";
import { getLocation, type Location } from "@src/appV2/redesign/utils/routes";

import { useOpenZendeskHelpCenter } from "./useOpenZendeskHelpCenter";

export type HelpCenterEntry =
  | { kind: "route"; routeTo: Location }
  | { kind: "action"; onClick: () => void };

/**
 * Resolves the destination for every Help Center entry point (left-nav, header
 * help button, mobile footer, legacy menu). With the kill-switch off, callers
 * navigate to the internal Help Center route as before. With it on, callers
 * open the authenticated Zendesk HC via SSO in a new tab / capacitor browser.
 */
export function useHelpCenterEntry(): HelpCenterEntry {
  const isSsoEnabled = useIsZendeskHelpCenterSsoEnabled();
  const openZendesk = useOpenZendeskHelpCenter();

  if (isSsoEnabled) {
    return { kind: "action", onClick: openZendesk };
  }

  return { kind: "route", routeTo: getLocation("helpCenter") };
}
